/*
 * Copyright (c) 2020.
 * Company: www.gwdang.com
 * Author: wanghui
 * Email: wanghui@gwdang.com
 */

const TB_SITE = [83, 8, 123];

let TransUrl = {

    run () {
        $('body').on('click', 'a[istransurl=\'1\']', (e) => {
            let item = e.target;
            if (item.tagName.toLowerCase() !== 'a') {
                item = $(item).parents('a[istransurl=\'1\']')[0];
            }
            const type = item.getAttribute('transurl-type') || 'item';
            const data = item.getAttribute('transurl-data');
            const site = item.getAttribute('transurl-site');
            const position = item.getAttribute('transurl-position') || 'gwd_dp';
            console.log(type, data, site, position);

            if (TB_SITE.indexOf(Number(site)) > -1) {
                // $(item).on('click', (evt) => {
                    //if (item.getAttribute('href').indexOf('uland') === -1) {
                        e.preventDefault();
                        let noCoupon = false
                        if ($(item).parents('.dp-item').length) {
                            noCoupon = true
                        }
                        this.addClickEvent(item, site, type, data, position, noCoupon);
                    //}
                // })
            }
        });
        /*
        document.querySelectorAll('a[istransurl=\'1\']').forEach((item, index) => {
            const type = item.getAttribute('transurl-type') || 'item';
            const data = item.getAttribute('transurl-data');
            const site = item.getAttribute('transurl-site');
            const position = item.getAttribute('transurl-position') || 'dp';

            console.log(type, data, site, position);

            if (TB_SITE.indexOf(Number(site)) > -1) {
                $(item).on('click', (evt) => {
                    if (item.getAttribute('href').indexOf('uland') === -1) {
                        evt.preventDefault();
                        this.addClickEvent(item, site, type, data, position);
                    }
                })
            }
        });
        */
    },

    async addClickEvent(dom, site, type, data, position, noCoupon) {
        let target_url = dom.getAttribute('href');
        try {
            if (type === 'item') {
                let transObj = await this.transItem(data, position, '', '', noCoupon);
                if (transObj[data]) {
                    target_url = transObj[data];
                    dom.setAttribute('href', target_url)
                }
            }
        } finally {
            if (dom.getAttribute('target') === '_blank') {
                window.open(target_url);
            } else {
                window.location.href = target_url;
            }
        }
    },

    async transItem (dp_id, position, url, is_coupon, no_coupon) {
        url = url || '';
        is_coupon = is_coupon || 0;
        return new Promise((resolve, reject) => {
            let from = position;
            if (from != 'gwd_dp') {
                from = `${position}_website`;
            }
            let data = [
                `dp_id=${dp_id}`,
                `from=${from}`,
                `url=${encodeURIComponent(url)}`,
                `is_coupon=${is_coupon}`
            ];
            if (no_coupon) {
                data.push('no_coupon=1')
            }
            let data_str = data.join('&');
            $.ajax({
                url: (location.hostname.includes('bijiago') ? '/bjg': '') + `/product/get_trans?${data_str}`,
                async:false,
                success (data) {
                    if (data) {
                        let parsed_data = JSON.parse(data);
                        if (parsed_data.code == 0) {
                            resolve(parsed_data.data);
                        }

                        reject(parsed_data);
                    }

                    reject('');
                },
                error (jqXHR, textStatus, errorThrown) {
                    console.error(jqXHR);
                    reject('');
                }
            })
        })
    }
};

export default TransUrl;
